import type { AssetId } from 'owa-timestream-store';
import getStore from '../store';

export default function isSelectedAsset(assetId: AssetId) {
    return getStore().selectedAssets.indexOf(assetId) != -1;
}
